
class ProjectRouteGetter {
  static readonly index = '/dashboard/projects';

  static get params() {
    return {
      projectId: ':id',
      orderId: ':order_id',
    };
  }

  static newPage(isAdmin = false) {
    if (isAdmin) {
      return `${this.index}/new`;
    }
    return `${this.index}/new`;
  }

  static page(projectId: string | number, isAdmin = false) {
    if (isAdmin) {
      return `${this.index}/${projectId}`;
    }
    return `${this.index}/${projectId}`;
  }

  static overview(projectId: string | number) {
    return `${this.page(projectId)}/overview`;
  }

  static scripts(projectId: string | number) {
    return `${this.page(projectId)}/scripts`;
  }

  static activity(projectId: string | number) {
    return `${this.page(projectId)}/activity`;
  }

  static media(projectId: string | number) {
    return `${this.page(projectId)}/media`;
  }

  static studio(projectId: string | number) {
    return `${this.scripts(projectId)}/studio`;
  }

  static admin(projectId: string | number) {
    return `${this.page(projectId)}/admin`;
  }

  static orders(projectId: string | number) {
    return `${this.page(projectId)}/orders`;
  }

  static order(projectId: string | number, orderId: string | number) {
    return `${this.page(projectId)}/orders/${orderId}`;
  }

  static pagePath(isAdmin = false) {
    return this.page(this.params.projectId, isAdmin);
  }

  static scriptsPath() {
    return this.scripts(this.params.projectId);
  }

  static activityPath() {
    return this.activity(this.params.projectId);
  }

  static mediaPath() {
    return this.media(this.params.projectId);
  }

  static studioPath() {
    return this.studio(this.params.projectId);
  }

  static overviewPath() {
    return this.overview(this.params.projectId);
  }

  static adminPath() {
    return this.admin(this.params.projectId);
  }

  static ordersPath() {
    return this.orders(this.params.projectId);
  }

  static orderPath() {
    return this.order(this.params.projectId, this.params.orderId);
  }
}

export default ProjectRouteGetter;
